module.exports = "/images/antaros-logo.svg?2030b83aa30623da125ea36dd0c848a4";